// removed by extract-text-webpack-plugin
module.exports = {"event-review-list-button":"_2X2WreZJ3 XqucEz17o _1jY4uEptA _2ltOFCwED _1lCmGBorg yJ3aJSEV8 _1B4qcaoCi _3ugGu5boG _3kvYUMIJc KjSy6bSLs _1yJuXbiru _3QqAd54bs _1gHeemEDk _3-7RXEMuO _3R_kicQee _3FDZP6-k- _1s6tZE1os _3IOMZqpxP _1II0OCq4x _3l91ZaNqh pzmz6Pfas _1uiaXoSwY _3SkDFIxdj _2l0xl0HVf _3C8l8JJzR _3cWZ9MSKx _1Q0mdYeBF _3v9QXXXDN _3BiTzCAU- _3uKzqKb8t OSBVy-e59 _3hAOedd31 _2zVYNxcNW _1t9KApSC5 _1bU7cv22t _3GjsU5YA9 _18kRtfb1J sfgVU1Uym _2RcNZKn0G xOCqVN8WB _17bhaKJ65 _2L5PVbM3P _1QSJutmfA _3s01LvMDS _2i4WtDBfq X7wdMy4UH"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/event-review-list-button/event-review-list-button.css
 ** module id = 2108
 ** module chunks = 0
 **/